export const HIGHCHARTS_ESG_POS_NEG_DEFAULT_OPTIONS = {
    chart: {
        height: 100,
        marginRight: 20,
        spacing: [0, 0, 0, 0],
        type: 'bar',
    },
    credits: undefined,
    exporting: {
        enabled: false,
    },
    plotOptions: {
        bar: {
            allowPointSelect: false,
            borderRadius: 0,
            borderWidth: 0.5,
            dataLabels: {
                enabled: true,
                color: '#000000',
                formatter() {
                    const percentage = this.point.y.toFixed(2);
                    return `<div>${percentage}%</div>`;
                },
                style: {
                    fontFamily: 'Roboto Condensed',
                    fontSize: '15',
                    fontWeight: 'normal',
                    textOutline: 'none',
                },
                useHTML: true,
            },
            groupPadding: 0,
            pointPadding: 0.2,
        },
        series: {
            states: {
                inactive: {
                    opacity: 1,
                },
            },
        },
    },
    legend: {
        enabled: false,
    },
    series: [
        {
            data: [],
        },
    ],
    title: {
        text: '',
    },
    tooltip: {
        enabled: false,
    },
    xAxis: {
        categories: ['Positive', 'Negative'],
        labels: {
            align: 'left',
            reserveSpace: true,
            style: {
                color: '#000000',
                fontFamily: 'Roboto Condensed',
                fontSize: '14',
                fontWeight: 'normal',
                textOutline: 'none',
            },
        },
        lineColor: '#e6e6e6',
    },
    yAxis: {
        gridLineWidth: 0,
        labels: {
            style: {
                fontFamily: 'Roboto Condensed',
            },
        },
        lineColor: '#e6e6e6',
        lineWidth: 1,
        max: 100,
        tickInterval: 20,
        title: {
            text: '',
        },
    },
};
export const NODATA_CLASS = 'noData';
export const NODATA_DEFAULT_MESSAGE = '<p>There are no valid items on this chart.</p>';
